import { BCMSDate, useModel, useRoute } from "@bcm-dev/bcms-vite";
import { useMultiPay } from "compid/workflows/MultiPay";
import { Bill } from "model/";

import ButtonContainer from 'compid/shared/containers/ButtonContainer';
import BillerView from "compid/shared/views/BillerView";
import BillerPaymentView from "compid/shared/views/BillerView/components/views/BillerPaymentView";
import UIButton from 'compid/ui/UIButton';
import UICheckbox from 'compid/ui/UICheckbox';
import { SVGAsset } from 'res';

export default function UpcomingBillerView(props) {
    const model = useModel();
    const { toggleAdd, state, submit } = useMultiPay() ?? {};
    const navigate = useRoute();

    const billers = model.bills.reduce((result, item) => {
        const bill = Bill.initByID(item.billID);

        const isIncluded = state.includes(bill.id);
        const shouldDisable = state.length > 0;

        const disabledClass = shouldDisable ? "disabled-gray" : "";
        const billerIsAdded = bill.biller.addType !== "quick_add" && bill.biller.addType !== "verification_add";

        const onClick = evt => !shouldDisable
            ? navigate(`/makeAPayment/${ bill.id }`)
            : undefined;

        // "Reminder" is a property of bill, but not all bills will have reminders.
        const reminder = bill.reminder;
        const billHasReminder = bill.reminder.id !== undefined;

        // Filter out bills with reminders with
        // "daysToRemindMeInAdvanced" out of date range.
        if(billHasReminder) {
            var daysToRemindMeInAdvanced = reminder.daysToRemindMeInAdvanced;
            var dueDate = reminder.dueDate;
            var dueDateMinusDaysInAdvanced = dueDate.offset(-daysToRemindMeInAdvanced);
            var today = BCMSDate.init();
            if(dueDateMinusDaysInAdvanced.isAfter(today)) {
                return result;
            }
        }

        // American Energy (id 7) is the only upcoming bill shown for now.
        return bill.status.toLowerCase() == "due" && billerIsAdded
            ? result.concat(
                <BillerView 
                    key={ "bill_" + bill.id }
                    biller={ bill.biller }
                    className={ isIncluded ? "selected-biller-view upcoming-biller-view-container" : "upcoming-biller-view-container" }
                    checkbox={ <UICheckbox value={ isIncluded } onChange={ value => toggleAdd(value, bill.id) } dataPoint={ `Upcoming_Bill_Checkbox_${ bill.id }` } /> }
                    dataPoint={ "Upcoming_Bills_Biller" }
                    paymentInfo={
                        <BillerPaymentView 
                            amount={ bill.amount }
                            status={ bill.status }
                            date={ bill.formatDate }
                            description={ bill.description }
                            payment={ bill.payment }
                            dataPoint={ `Upcoming_Bills_Bill_${ bill.id }` } />
                    }
                    buttons={
                        <>
                            { !isIncluded && 
                                <ButtonContainer className="set-width">
                                    <UIButton className={ `primary-button ${ disabledClass }` } onClick={ onClick } dataPoint={ `Upcoming_Bills_Pay_${ bill.id }` }>Pay</UIButton>
                                </ButtonContainer> }

                            { isIncluded &&
                                <ButtonContainer>
                                    <UIButton 
                                        className="primary-button multipay-btn" 
                                        dataPoint={ `Upcoming_Bills_Pay_${ bill.id }` }
                                        onClick={ submit }>Pay { state.length } biller{ state.length > 1 ? "s" : "" }</UIButton>
                                </ButtonContainer> }
                        </>
                    } />
            )
            : result;
    }, []);

    return <> { billers.length > 0 ? billers : <NoUpcomingBillsWidget /> } </>;
}

// NOTE: This should be moved into a new component
function NoUpcomingBillsWidget() {
    return (
        <div className="no-upcoming-bills-widget row-container">
            <div className="flex-container flex-horizontal align-center row-main-content">
                {/* Screenshots show two different assets in mobile and desktop - this is reflected below. */}
                <SVGAsset id="UpsellIcon" className="show-on-desktop blue-icon logo set-width logo-container"></SVGAsset>
                <SVGAsset id="UpsellIcon" className="logo set-width logo-container show-on-mobile"></SVGAsset>
                <div className="flex-width">
                <span>You don't have any unpaid bills at this time.</span>
                </div>
            </div>
        </div>
    );
}